// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_body h4 {
  display: flex;
  align-items: center;
  justify-content: center;
}

.model_btn {
  margin-right: 10px;
  padding: 10px 20px;
  border: 0px solid #e837ff !important;
  color: #7511d3;
  letter-spacing: 1.25px;
  background: transparent;
  font-size: 10px;
  font-weight: 600;
  font-family: "Poppins", sans-serif !important;
  font-weight: semibold;
  transition: background-color 0.3s ease;
}

.qr-img {
  transition: all 0.3s ease;
}

.download_btn {
  /* font-size: large; */
  padding: 0.7rem 2rem;
  border: 2px solid #d2d3d3 !important;
  border-radius: 3rem !important;
  margin-bottom: -0.5rem !important;
  top: 0.8rem;
  color: #681b8c !important;
  font-family: Arial, Helvetica, sans-serif;
  letter-spacing: 0px;
  font-weight: 500;
}

.download_btn > div {
  display: flex;
  text-align: left;
  align-items: center;
}

.download_text {
  font-size: x-small;
  margin-bottom: -0.3rem !important;
}

.download_btn span {
  color: #681b8c;
  font-size: 1rem !important;
  font-weight: 500 !important;
}

@keyframes shake {
  0% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0);
  }
}

.model_btn:hover,
.qr-img:hover {
  animation: shake 0.5s;
}

.blur-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
  z-index: 999; /* Make sure it's below the modal */
}
`, "",{"version":3,"sources":["webpack://./src/ContactUs/model.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,yBAAyB;EACzB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAA0B;UAA1B,0BAA0B;EAC1B,YAAY,EAAE,mCAAmC;AACnD","sourcesContent":[".modal_body h4 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.model_btn {\n  margin-right: 10px;\n  padding: 10px 20px;\n  border: 0px solid #e837ff !important;\n  color: #7511d3;\n  letter-spacing: 1.25px;\n  background: transparent;\n  font-size: 10px;\n  font-weight: 600;\n  font-family: \"Poppins\", sans-serif !important;\n  font-weight: semibold;\n  transition: background-color 0.3s ease;\n}\n\n.qr-img {\n  transition: all 0.3s ease;\n}\n\n.download_btn {\n  /* font-size: large; */\n  padding: 0.7rem 2rem;\n  border: 2px solid #d2d3d3 !important;\n  border-radius: 3rem !important;\n  margin-bottom: -0.5rem !important;\n  top: 0.8rem;\n  color: #681b8c !important;\n  font-family: Arial, Helvetica, sans-serif;\n  letter-spacing: 0px;\n  font-weight: 500;\n}\n\n.download_btn > div {\n  display: flex;\n  text-align: left;\n  align-items: center;\n}\n\n.download_text {\n  font-size: x-small;\n  margin-bottom: -0.3rem !important;\n}\n\n.download_btn span {\n  color: #681b8c;\n  font-size: 1rem !important;\n  font-weight: 500 !important;\n}\n\n@keyframes shake {\n  0% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-5px);\n  }\n  50% {\n    transform: translateX(5px);\n  }\n  75% {\n    transform: translateX(-5px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n.model_btn:hover,\n.qr-img:hover {\n  animation: shake 0.5s;\n}\n\n.blur-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  backdrop-filter: blur(5px);\n  z-index: 999; /* Make sure it's below the modal */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
